define('modules/form_editor/views/preview_custom_google_recaptcha',['require','exports','module','./preview_base','../../editor/models/editorstate','../config','ldsh!../templates/preview_custom_recaptcha_amp','ldsh!../templates/preview_custom_googlecaptcha'],function(require, exports, module){
  "use strict";
  var PreviewBase = require("./preview_base"),
      EditorState = require("../../editor/models/editorstate"),
      CaptchaConfig = require("../config");

  module.exports = PreviewBase.extend({
    template: null,

    initialize: function(options){
      this.template = EditorState.getAMPState() ?
          require("ldsh!../templates/preview_custom_recaptcha_amp") :
          require("ldsh!../templates/preview_custom_googlecaptcha");

      module.exports.__super__.initialize.apply(this, arguments);
    },

    helpers: function () {
      return {
        siteKey: this.model.get('siteKey') ||
            CaptchaConfig.googleRecaptcha.getSiteKey()
      };
    }
  });
});

